import Link from 'next/link';

import Props from '@/components/app/side-in/components/banner/type';

import { DATA_CY_SIDEIN_LINK } from '@/constant/cypress';

export default function Banner({ link, image }: Props) {
  return (
    <Link
      href={link}
      target='_blank'
      className='h-full w-full'
      prefetch={false}
      data-cy={DATA_CY_SIDEIN_LINK}
    >
      <img src={image?.publicLink} alt={image.title || 'side-in'} />
    </Link>
  );
}
